import React from 'react';
import {useAPI} from "../../components/hooks/api";

export default function MailchimpConfiguration() {
    return <div>Mailchimp is configured! Click next continue</div>
}
